import React from "react";
import "./App.css";

import Navbar from "./components/Navbar";
import Uvod from "./pages/index";
import Kontakt from "./pages/Kontakt";
import Obory from "./pages/Obory";
import Footer from "./components/Footer";

import Galerie from "./pages/Galerie";
import Documents from "./pages/Documents";
import ChciNaZus from "./pages/Chcinazus";

import Prihlaska from "./pages/chcinazus/Prihlaska";
import Prijmacky from "./pages/chcinazus/Prijmacky";
import Priprava from "./pages/chcinazus/Priprava";

import Foto from "./pages/galerie/Foto";
import Video from "./pages/galerie/Video";

import Hudebni from "./pages/obory/Hudebni";
import Tanecni from "./pages/obory/Tanecni";
import Vytvarni from "./pages/obory/Vytvarni";

import Absolventi from "./pages/uvod/Absolventi";
import Historie from "./pages/uvod/Historie";
import Pracoviste from "./pages/uvod/Pracoviste";
import Soucasnost from "./pages/uvod/Soucasnost";
import Zamestnanci from "./pages/uvod/Zamestnanci";
import TeachersList from "./data/TeachersList";
import Payment from "./pages/uvod/Payment";
import Projekty from "./pages/Projekty";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  useLocation,
} from "react-router-dom";
import AdminLogin from "./pages/admin/adminlogin";
import PrijmaciRizeniPage from "./pages/prijmaciRizeni/prijmaci-rizeni";
import NotFound from "./pages/404";
import { AdmissionList } from "./pages/prijmaciRizeni/export";
import { Newspaper } from "lucide-react";
import AktualityContainer from "./pages/Aktuality";
import NewsItemPage from "./components/newsID";
import NovinkyPage from "./pages/admin/NovinkyPage";
import UzivatelePage from "./pages/admin/UzivatelePage";
import ZamestnanciPage from "./pages/admin/ZamestnanciPage";
import PrijimaciRizeniPage from "./pages/admin/PrijimaciRizeniPage";
import ExportPrijPage from "./pages/admin/ExportPrijPage";

import ProtectedRoute from "./components/protectedRoutes";
import BranchesPage from "./pages/uvod/Pracoviste";
import Gallery from "./pages/gallery";

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.includes('/adminlogin') || location.pathname === '/newdash' || location.pathname === '/prijmacirizeni';
  const isPrijmacky = location.pathname.includes('/chcinazus/prijmacirizeni');
  const news = location.pathname.includes('/news/');
  const dashboard = location.pathname.includes("/dashboard") || location.pathname === '/dashboard/novinky' || location.pathname === '/dashboard/uzivatele' || location.pathname === '/dashboard/zamestnanci' || location.pathname === '/dashboard/prijimacirizeni' || location.pathname === '/dashboard/prijimacirizeniexport';

  return (
    <div className="App">
        {!isAdminPage && !news && !dashboard && <Navbar />}
        <main>
          <Routes>
            <Route path="/" element={<Uvod />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/obory" element={<Obory />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/chcinazus" element={<ChciNaZus />} />

            <Route path="chcinazus/prihlaska" element={<Prihlaska />} />
            <Route path="chcinazus/prijmacky" element={<Prijmacky />} />
            <Route path="chcinazus/priprava" element={<Priprava />} />
            <Route path="chcinazus/prijmacirizeni" element={<PrijmaciRizeniPage />} />

            <Route path="/galerie/foto" element={<Foto />} />
            <Route path="/galerie/video" element={<Video />} />

            <Route path="/obory/hudebni" element={<Hudebni />} />
            <Route path="/obory/tanecni" element={<Tanecni />} />
            <Route path="/obory/vytvarny" element={<Vytvarni />} />

            <Route path="/uvod/absolventi" element={<Absolventi />} />
            <Route path="/uvod/historie" element={<Historie />} />
            <Route path="/uvod/pracoviste" element={<BranchesPage />} />
            <Route path="/uvod/soucasnost" element={<Soucasnost />} />
            <Route path="/uvod/teachers" element={<TeachersList />} />
	          <Route path="/uvod/payment" element={<Payment />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/projekty" element={<Projekty />} />

            <Route path="/aktuality" element={<AktualityContainer />} />
            <Route path="/aktuality/:id" element={<NewsItemPage />} />
            <Route path="/404" element={<NotFound/>}/>

            <Route path="/adminlogin" element={<AdminLogin />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<NovinkyPage />} />
              <Route path="/dashboard/novinky" element={<NovinkyPage />} />
              <Route path="/dashboard/uzivatele" element={<UzivatelePage />} />
              <Route path="/dashboard/zamestnanci" element={<ZamestnanciPage />} />
              <Route path="/dashboard/prijimacirizeni" element={<PrijimaciRizeniPage />} />
              <Route path="/dashboard/prijimacirizeniexport" element={<ExportPrijPage />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        {!isAdminPage && !isPrijmacky && !news && !dashboard && <Footer />}
    </div>
  );
}

export default App;